export default function getUniqueArray<T>(
    array: T[],
    comparator: (a: T, b: T) => boolean = (a: T, b: T) => a === b
) {
    return array.filter((a, index) => array.findIndex(item => comparator(a, item)) === index);
}